<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Name" formControlName="name">
    <form-group-simple name="name" placeholder="Name"></form-group-simple>
  </form-group-context>


  <form-group-context label="Store" formControlName="parentStore">
    <form-group-select entity="store"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="null"
                       bindValue="id"
                       placeholder="Store"></form-group-select>
  </form-group-context>


  <form-group-context label="Google product id" formControlName="googleProductId">
    <form-group-simple name="googleProductId" placeholder="Google product id"></form-group-simple>
  </form-group-context>

  <form-group-context label="Apple product id" formControlName="appleProductId">
    <form-group-simple name="appleProductId" placeholder="Apple product id"></form-group-simple>
  </form-group-context>


  <form-group-context label="Inner product" formControlName="innerProduct">
    <form-group-simple type="checkbox" name="innerProduct"></form-group-simple>
  </form-group-context>

  <form-group-context label="Coins cost" formControlName="coinsCost"
                      *ngIf="form.get('coinsCost')">
    <form-group-simple name="coinsCost" inputType="number" placeholder="Coins cost"></form-group-simple>
  </form-group-context>

  <form-group-context label="Types" formControlName="type">
    <form-group-select [searchable]="true"
                       [items]="types"
                       placeholder="Type">
    </form-group-select>
  </form-group-context>


  <form-group-context label="Entity" formControlName="entity"
                      *ngIf="form.get('entity')">
    <form-group-select bindLabel="label"
                       [searchable]="true"
                       [items]="entities"
                       bindValue="key"
                       placeholder="Entity"></form-group-select>
  </form-group-context>


  <form-group-context label="Project" formControlName="project"
                      *ngIf="form.get('project') && form.get('entity').value === 'project'">
    <form-group-select entity="project"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="{store: data?.parentStore?.id || data?.parentStore}"
                       bindValue="id"
                       placeholder="Project"></form-group-select>
  </form-group-context>


  <form-group-context label="Collection"
                      formControlName="storeCollection"
                      *ngIf="form.get('storeCollection') && form.get('entity').value === 'storeCollection'">
    <form-group-select entity="storeCollection"
                       bindLabel="name"
                       [storeQuery]="{store: data?.parentStore?.id || data?.parentStore}"
                       [searchable]="true"
                       bindValue="id"
                       placeholder="Collection"></form-group-select>
  </form-group-context>


  <form-group-context label="Amount" formControlName="coinsValue"
                      *ngIf="form.get('coinsValue')">
    <form-group-simple name="coinsValue" inputType="number" placeholder="amount"></form-group-simple>
  </form-group-context>

    <form-group-context label="Subscription period" formControlName="subscriptionPeriod"
                        *ngIf="form.get('subscriptionPeriod')">
      <form-group-simple name="subscriptionPeriod" inputType="number" placeholder="0"></form-group-simple>
    </form-group-context>



  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
